export default __webpack_public_path__ + "static/media/hotmart.e921a823.svg";